import { styles } from "./styles";
import { AdminCentreButtonsView } from "./view";
import React from "react";

export class AdminCentreButtons extends React.Component {
  render() {
    return <AdminCentreButtonsView styles={styles} {...this.props} />;
  }
}
